import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalsService } from '../_services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class DistrictHeatingService {
  constructor(
    private http: HttpClient,
    private gs: GlobalsService
  ) {}

  getSystemDetails(id: string | number): Observable<any> {
    return this.http.get<any>(
      this.gs.getRestUrl() + '/api/daljinskoogrevanje/sistem/' + id
    );
  }

  getHouseDetails(stavbaId: string | number, sistemId: string | number): Observable<any> {
    return this.http.get<any>(
      this.gs.getRestUrl() + '/api/daljinskoogrevanje/stavba/' + stavbaId + '/sistem/' + sistemId
    );
  }

  getHouses(obMid: string | number): Observable<any[]> {
    return this.http.get<any[]>(
      this.gs.getRestUrl() + '/api/daljinskoogrevanje/stavbe/' + obMid
    );
  }

  getSystems(obMid: string | number): Observable<any[]> {
    return this.http.get<any[]>(
      this.gs.getRestUrl() + '/api/daljinskoogrevanje/sistemi/' + obMid
    );
  }
}